import { DesignerParams } from '@/types';
import { isDefined } from '@/utils/isDefined';

let params: DesignerParams;

if (process.env.NODE_ENV === 'test') {
  params = {} as DesignerParams;
}

export const setParams = (nextParams: DesignerParams) => {
  if (isDefined(params) && process.env.NODE_ENV !== 'test') {
    throw new Error('params are immutable and should only be set once!');
  }
  params = { ...nextParams };
};

export const getParams = () => {
  if (!isDefined(params)) {
    throw new Error('params not set before first get!');
  }
  return params;
};

export const isCYOMode = () => !isUserAreaMode() && !isAdminMode() && params.subMode === 'd2c';
export const isShopMode = () => !isUserAreaMode() && !isAdminMode() && params.subMode !== 'd2c';
export const isUserAreaMode = () => params.mode === 'userarea';
export const isAdminMode = () => params.mode === 'admin';
export const isTemplateAdminMode = () => params.mode === 'template-admin';
export const hasUserAPI = () => Boolean(params.getCurrentLoginState && params.openLogin);
export const isEmbroideryMode = () => params.embroideryMode;
export const isSmartomat = () => params.client === 'Smartomat';
export const isInches = () => params.locale === 'en_GB' || params.platform === 'NA';
export const isABTestActive = (test: string) =>
  params.abTests?.includes(test) || params.ABTest === test;
